const chatbox = document.getElementById('combine-chatbox');
const is_combine_zalo = chatbox.dataset.zaChat;
const is_combine_facebook = chatbox.dataset.facebook;
function toggleZalo() {
    function doToggle() {
        const zaloElement = document.querySelector('#razl-widget');
        if (!zaloElement) return false;
        let state = zaloElement.style.display;
        if(state === 'none' || state === ''){
            zaloElement.style.display = 'block';
        } else {
            zaloElement.style.display = 'none';
        }
        return true;
    }
    if (!doToggle()) {
        const observer = new MutationObserver(function(mutations, obs) {
            if (doToggle()) {
                obs.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
}
function hideZalo(){
    function doHide() {
        const zaloElement = document.querySelector('#razl-widget');
        if (!zaloElement) return false;
        zaloElement.style.display = 'none';
        return true;
    }
    if (!doHide()) {
        const observer = new MutationObserver(function(mutations, obs) {
            if (doHide()) {
                obs.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
}

document.addEventListener('DOMContentLoaded', function() {

    if(is_combine_zalo) hideZalo();

    // Wait for .Vtl-LiveChatChannelsWidget to appear in the DOM
    function addLiveChatListener() {
        const widget = document.querySelector('.Vtl-LiveChatChannelsWidget');
        if (widget) {
            widget.addEventListener('click', function() {
                if(is_combine_zalo == false) return; // If Facebook is enabled, do nothing
                let state = widget.getAttribute('data-state');
                if(state === 'open' || !state){
                    toggleZalo();
                    widget.setAttribute('data-state', 'open');
                }else{
                    hideZalo();
                    widget.setAttribute('data-state', 'close');
                }
            });
            return true;
        }
        return false;
    }

    if (!addLiveChatListener()) {
        const observer = new MutationObserver(function(mutations, obs) {
            if (addLiveChatListener()) {
                obs.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
});
